export const faqData = [
  {
    id: 1,
    question:
      "How accurate is the Minemi Personal Loan Eligibility Calculator?",
    answer:
      "Our calculator provides highly accurate estimates based on the data you input. However, actual approval depends on lender-specific criteria.",
  },
  {
    id: 2,
    question: "Does using the calculator impact my credit score?",
    answer:
      "No, the calculator uses a soft inquiry process and doesn’t affect your credit score.",
  },
  {
    id: 3,
    question:
      "Can I apply for a personal loan immediately after checking my eligibility?",
    answer:
      "Yes, if your results are favorable, you can proceed to compare and apply for loans with confidence.",
  },
  {
    id: 4,
    question: "What happens if my eligibility is low?",
    answer:
      "You can take steps to improve your profile, such as reducing debts, improving your credit score, or increasing your income, before rechecking eligibility.",
  },
];
